/**
 * リダクションステータス
 */
export var ReductionStatuses;

(function (ReductionStatuses) {
  /**
   * 未処理
   */
  ReductionStatuses[ReductionStatuses["Untreated"] = 0] = "Untreated";
  /**
   * 処理待ち
   */

  ReductionStatuses[ReductionStatuses["Wait"] = 1] = "Wait";
  /**
   * 処理中
   */

  ReductionStatuses[ReductionStatuses["Processing"] = 2] = "Processing";
  /**
   * 正常終了
   */

  ReductionStatuses[ReductionStatuses["Success"] = 3] = "Success";
  /**
   * 異常終了
   */

  ReductionStatuses[ReductionStatuses["Failure"] = 4] = "Failure";
  /**
   * キャンセル
   */

  ReductionStatuses[ReductionStatuses["Cancel"] = 5] = "Cancel";
})(ReductionStatuses || (ReductionStatuses = {}));